import Heading from "common/components/Typography/Heading/Heading";
import React from "react";
import { Col } from "react-bootstrap";
import { Row } from "react-bootstrap";
import styles from "./OneRecibo.module.css";
import { formatCurrency } from "common/helpers/DataFormat";
import { Container } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Trash2Fill } from "react-bootstrap-icons";
import { Trash } from "react-bootstrap-icons";
import { FiletypePdf } from "react-bootstrap-icons";
import { FiletypeXml } from "react-bootstrap-icons";
export default function OneRecibo(props){
    const {pos,data,onButtonCallBack} = props;
    return <div className={styles.container}>
            
                                <Container>
                                    <Row>
                                    <Col xs={8}>
                                        <Row>
                                            <Col><Heading variant="h4">Recibo o Invoice #{pos+1}</Heading></Col>
                                        </Row>
                                        <Row>
                                            <Col>Archivo: {data.file.original_name}</Col>
                                        </Row>
                                        <Row>
                                            <Col>Serie: {data.serie}</Col>
                                        </Row>
                                        <Row>
                                            <Col>Número: {data.numero}</Col>
                                        </Row>
                                        <Row>
                                            <Col>Monto: {data.moneda} {data.monto}</Col>
                                        </Row>
                                    </Col>
                                    <Col>
                                        <Row className={styles.buttonsfel}>
                                            
                                            <Col>
                                                <Button className={styles.btnfel} onClick={()=> onButtonCallBack("PDF",data.file) }><FiletypePdf /> PDF</Button>
                                            </Col>
                                            <Col>
                                                <Button className={styles.btnfel} variant="danger" onClick={()=> onButtonCallBack("delete",{ pos: pos }) }><Trash /> </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                    </Row>
                                </Container>
         

    </div>;
}